// 登录
import service from '@/utils/request'

// 身份证审核列表
export function userverifyList (data) {
  return service({
    url: '/service/admin/userverify_list',
    method: 'post',
    params: data
  })
}
// 身份证审核列表
export function userSetverifystatus (data) {
  return service({
    url: '/service/admin/user_setverifystatus',
    method: 'post',
    params: data
  })
}
// 身份证详情
export function userView (data) {
  return service({
    url: '/service/admin/user_view',
    method: 'post',
    params: data
  })
}
// 举报列表
export function tipsList (data) {
  return service({
    url: '/service/admin/tips_list',
    method: 'post',
    params: data
  })
}
// 举报列表
export function posttipsSetverifystatus (data) {
  return service({
    url: '/service/admin/posttips_setverifystatus',
    method: 'post',
    params: data
  })
}
// 举报列表
export function posttipsView (data) {
  return service({
    url: '/service/admin/posttips_view',
    method: 'post',
    params: data
  })
}
// 意见反馈列表
export function feedbackList (data) {
  return service({
    url: '/service/admin/feedback_list',
    method: 'post',
    params: data
  })
}
// 意见反馈审核操作
export function feedbackSetstatusval (data) {
  return service({
    url: '/service/admin/feedback_setstatusval',
    method: 'post',
    params: data
  })
}
// 意见反馈审核操作
export function feedbackView (data) {
  return service({
    url: '/service/admin/feedback_view',
    method: 'post',
    params: data
  })
}
// 意见反馈审核操作
export function feedbackSubremark (data) {
  return service({
    url: '/service/admin/feedback_subremark',
    method: 'post',
    params: data
  })
}
